import { useGoBack } from 'hooks/useGoBack';
import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import { convertUndefinedFields } from 'utils/helpers';
import {
	IEditFormForClientManagerContext,
	EditFormForClientManagerContext,
} from '../../EditFormForClientManagerState/editFormForClientManagerContext';
import { AppContext, IAppContext } from 'appState/appContext';
import { updateRestaurant } from 'backend/restaurants';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IEditFormForClientManagerContext>(EditFormForClientManagerContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/clients/restaurants');
	}, [goBack]);

	const handleSubmitMainInfo = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateRestaurant(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleSubmitMainInfo}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleUpdateData}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
